import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "header-card-detail" }
const _hoisted_2 = { class: "flex w-full justify-between" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "px-5" }
const _hoisted_5 = { class: "flex w-full justify-between items-center" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "flex w-full justify-between" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "flex w-full" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = /*#__PURE__*/_createVNode("td", { class: "w-1/12 pr-5" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-sm font-semibold" }, "Alamat")
], -1)
const _hoisted_12 = { class: "w-11/12" }
const _hoisted_13 = { class: "text-black text-sm font-semibold" }
const _hoisted_14 = /*#__PURE__*/_createVNode("td", { class: "w-1/12 pr-5" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-sm font-semibold" }, "Kontak")
], -1)
const _hoisted_15 = { class: "w-11/12" }
const _hoisted_16 = { class: "text-black text-sm font-semibold" }
const _hoisted_17 = { class: "px-5" }
const _hoisted_18 = { class: "flex items-end h-full justify-between" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-sm font-semibold mr-3" }, "Diskon", -1)
const _hoisted_20 = { class: "label-orange-lighten-5 px-3 text-xs rounded-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "mb-4" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h5", null, _toDisplayString(_ctx.dataCustomerCompany.Nama), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_InputSwitch, {
                  disabled: !_ctx.route.meta.permission.update,
                  class: "switch-og mr-8",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIsActive(_ctx.dataCustomerCompany))),
                  modelValue: _ctx.dataCustomerCompany.IsActive,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataCustomerCompany.IsActive = $event))
                }, null, 8, ["disabled", "modelValue"])
              ]),
              (_ctx.route.meta.permission.update || _ctx.route.meta.permission.delete)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                    "aria:haspopup": "true",
                    "aria-controls": "overlay_panel",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDropDown && _ctx.showDropDown(...args)))
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_OverlayPanel, {
                ref: "op",
                id: "overlay_panel"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ListCopyEditDel, {
                    del: _ctx.route.meta.permission.delete,
                    edit: _ctx.route.meta.permission.update,
                    onDel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteData(_ctx.dataCustomerCompany.Id))),
                    onEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirectEdit(_ctx.dataCustomerCompany.Id)))
                  }, null, 8, ["del", "edit"])
                ]),
                _: 1
              }, 512)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("table", _hoisted_10, [
                _createVNode("tr", null, [
                  _hoisted_11,
                  _createVNode("td", _hoisted_12, [
                    _createVNode("p", _hoisted_13, _toDisplayString(_ctx.dataCustomerCompany.NamaKota) + " - " + _toDisplayString(_ctx.dataCustomerCompany.Alamat), 1)
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_14,
                  _createVNode("td", _hoisted_15, [
                    _createVNode("p", _hoisted_16, _toDisplayString(_ctx.dataCustomerCompany.NamaPic) + " (" + _toDisplayString(_ctx.dataCustomerCompany.TeleponPic) + ")", 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.dataCustomerCompany.Diskon) + "% ", 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}